
import "./jobsForm.css";
import { useContext, useRef } from 'react'
import FormInput from '../dashboardComponents/FormInput';
import FormTextarea from '../dashboardComponents/FormTextarea';
import { DashboardContext } from '../../../contextApi/DashboardContext';
import FormButton from '../dashboardComponents/FormButton';
import JobsList from './JobsList';
import { AppContext } from "../../../contextApi/ContextApi";

export default function AddJobForm({website}) {
    const { setToastMessage, messagesOptions } = useContext(AppContext);
    const { isAddJob, jobTitle, setJobTitle, jobDesc, setJobDesc, jobDetails, setJobDetails, jobRequirement, setJobRequirement, jobBenefit, setJobBenefit, jobReqs, setJobReqs, jobBenefits, setJobBenefits, handleAddJob, deployList} = useContext(DashboardContext);
    const titleRef = useRef(null);
    const descRef = useRef(null);
    const detailsRef = useRef(null);
    const resetInputs = ()=>{
        setJobDesc("");
        setJobTitle("");
        setJobDetails("");
        setJobBenefits([]);
        setJobReqs([]);
    }
    return (
        <form className='dashboardForm' dir='rtl'>
            <h2>טופס הוספת משרה חדשה</h2>
            <FormInput _class={"dashboardForm_section"} hasLabel={true} label={"תפקיד:"} id={"addJob_title"} type={"text"} _value={jobTitle} placeholder={"שם התפקיד"} onChangeAction={(e)=>{ setJobTitle(e.target.value)}} required={true} _ref={titleRef}/>
            <FormTextarea _class={"dashboardForm_section"} label={"תיאור כללי:"} id={"addJob_description"} _value={jobDesc} placeholder={"הוסף תיאור כללי על התפקיד"} onChangeAction={(e)=>{setJobDesc(e.target.value)}} required={true} _ref={descRef}/>
            <h3 style={{borderBottom:"0.5px solid black", width:"90%", margin:"30px auto"}}>פרטים נוספים על התפקיד</h3>
            <FormTextarea _class={"dashboardForm_section"} label={"תיאור מפורט:"} id={"addJob_details"} _value={jobDetails} placeholder={"הוסף תיאור מפורט על התפקיד"} onChangeAction={(e)=>{setJobDetails(e.target.value)}} required={true} _ref={detailsRef}/>
            <FormInput _class={"dashboardForm_section"} hasLabel={true} label={"דרישות התפקיד:"} id={"addJob_requirements"} type={"text"} placeholder={"הוסף דרישות תפקיד"} onChangeAction={(e)=>{ setJobRequirement(e.target.value)}} hasButton={true} buttonText={"הוסף"} buttonAction={()=>{setJobReqs([...jobReqs, jobRequirement])}} required={true} resetValue={true}/>
            {deployList(website,jobReqs, setJobReqs)}
            <FormInput _class={"dashboardForm_section"} hasLabel={true} label={"יתרונות התפקיד:"} id={"addJob_benefits"} type={"text"} placeholder={"יתרונות התפקיד -במידה ויש"} onChangeAction={(e)=>{ setJobBenefit(e.target.value)}} hasButton={true} buttonText={"הוסף"} buttonAction={()=>{setJobBenefits([...jobBenefits, jobBenefit])}} required={false} resetValue={true}/>
            {deployList(website,jobBenefits, setJobBenefits)}
            <FormButton disabled={isAddJob} website={website} type={'submit'} text={"הוסף משרה"} action={(e)=>{e.preventDefault();handleAddJob(website, setToastMessage, messagesOptions); resetInputs()}}/>
            <div style={{width:"90%"}}>
                {website?.settings?.jobs?.length > 0 && <JobsList website={website}/>}
            </div>
        </form>
    )
}
